/* istanbul ignore file */
export default (palette, typography) => ({
  background: palette.background,
  border: palette.form.border,
  breadcrumbFontFamily: typography.h3.fontFamily,
  breadcrumbColor: palette.primary.normal,
  clearIconFill: palette.grey.G400,
  clearIconFillHover: palette.primary.light,
  error: { borderColor: palette.form.error },
  fontFamily: typography.fontFamily,
  fontSize: 16,
  fontWeight: typography.fontWeight,
  highlightBg: '#cbe4ff',
  hoverBg: palette.highlightBackground,
  iconFill: palette.text.dark,
  placeholderColor: palette.text.midGray,
  text: palette.text.dark,
  focusColor: palette.focus.normal,
  optionHeader: palette.text.midGray,
  disabledBg: '#EDEDED',
  disabledText: palette.text.midGray,
  dark: {
    background: palette.primary.darkBackground,
    breadcrumbColor: palette.primary.light,
    errorBorderColor: '#FF9494',
    highlightBg: '#465575',
    hoverBg: '#465575',
    iconFill: palette.text.light,
    placeholderColor: palette.grey.G100,
    text: palette.text.light,
    darkFocusColor: palette.focus.dark,
    optionHeader: palette.text.light
  },
  checkbox: {
    borderColor: palette.grey.G400,
    selectedColor: palette.primary.normal,
    shadowColor: palette.grey.G400,
    checkColor: palette.text.light,
    dark: {
      borderColor: palette.text.light,
      selectedColor: palette.text.light,
      checkColor: palette.background.dark
    }
  }
});
